import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { FooterReport, Gap, Line } from "../../../../components/Global";

const LoadingPage = () => {
    require("../Pemetaan.css");
    return (
        <div className="report-page">
            <div className="cardLine">
                {/* <div className="pnl-header">
                    <div className="card-page">
                        <span style={{
                            fontSize: '26px',
                            color: '#FFF',
                            fontWeight: 500,
                            fontFamily: 'lucida grande'
                        }}>04</span>
                    </div>
                    <div className="pnl-date">
                        https://eduprime.co.id/
                    </div>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
                        <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="label-sub-tit">
                            <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
                        </div>
                    </div>
                </div>
                <Gap height={20} />
                <div style={{ width: "95%", paddingLeft: "5%" }}>
                    <Line color={"#1D3557"} />
                </div> */}
                <Gap height={20} />
                <div className="section-one">
                    <SkeletonTheme baseColor="#d4d2d2" highlightColor="#a6a6a6">
                        <Skeleton count={20} height={30} />
                    </SkeletonTheme>
                </div>
                {/* <Gap height={40} />
            <div className="reportFooter">
                <FooterReport color={"#1D3557"} date={"20/02/2022"} />
            </div> */}
            </div>
        </div>
    );
};

export default LoadingPage;
